let menu = {
	purchase: {
		module: '采购管理',
		theme: 'color_y',
		menu: {
			order: {
				route: 'purchase/list',
				title: '采购合同',
				icon: 'icon-gouwuche',
				weigh: 1,
			},
			enterlog: {
				route: 'purchase/enterlog',
				title: '入库记录',
				icon: 'icon-caigouruku-lan',
				weigh: 2,
			},
			// buyer: {
			// 	route: 'purchasec/list',
			// 	title: '采购价维护',
			// 	icon: 'iconfont icon-shuqian',
			// },
			supplierlist: {
				route: 'supplier/list',
				title: '供应商',
				icon: 'iconfont icon-icon-test',
				weigh: 3,
			},
			supplierverify: {
				route: 'supplier/verify',
				title: '供应商对账',
				icon: 'iconfont icon2-caiwu_gongyingshangduizhang',
				weigh: 4,
			},
		}
	},
	
	sales: {
		module: '销售管理',
		theme: 'color_g',
		menu: {
			ovlist: {
				route: 'sale/list/2/0',
				title: 'HK销售合同',
				icon: 'icon-zerenqingdan',
				weigh: 1,
			},
			ovsalesout: {
				route: '/saleo/list',
				title: 'HK销售出库',
				icon: 'icon-chuku',
				weigh: 2,
			},
			ovoutlog: {
				route: '/saleo/outlog/1',
				title: 'HK出库记录',
				icon: 'icon-chuku1',
				weigh: 3,
			},
			list: {
				route: 'sale/list/0/0',
				title: 'SZ销售合同',
				icon: 'icon-zerenqingdan',
				weigh: 4,
			},
			salesout: {
				route: '/saleo/list',
				title: 'SZ销售出库',
				icon: 'icon-chuku',
				weigh: 5,
			},
			outlog: {
				route: '/saleo/outlog/0',
				title: 'SZ出库记录',
				icon: 'icon-chuku1',
				weigh: 6,
			},
			ovsendlog: {
				route: '/saleo/sendlog/4',
				title: 'HK发货记录',
				icon: 'icon2-transport-full',
				weigh: 7,
			},
			sendlog: {
				route: '/saleo/sendlog/0',
				title: 'SZ发货记录',
				icon: 'icon2-transport-full',
				weigh: 8,
			},
			
			customer: {
				route: '/customer/list',
				title: '我的客户',
				icon: 'iconfont icon-lianhe4',
				weigh: 9,
			},
			
			customer_verify_order: {
				route: '/customer/verifyorder',
				title: '客户对账',
				icon: 'icon2-kehuduizhang',
				weigh: 10,
			},
			
			jishou: {
				route: 'sale/list/3',
				title: '我的寄售单',
				icon: 'iconfont icon-icon',
				weigh: 10,
			}
		}
	},
	sku: {
		module: 'SKU管理',
		theme: 'color_o',
		menu: {
			list: {
				route: 'sku/list',
				title: 'SKU',
				icon: 'icon2-chanpin',
				weigh: 1,
			},
		}
	},
	inventory: {
		module: '库存管理',
		theme: 'color_b',
		menu: {
			inventory_administration: {
				route: 'inventoryMgt',
				title: '库存统计',
				icon: 'icon-statistic-right2',
				weigh: 1,
			},
			
			transfer: {
				route: '/transfern/list',
				title: '转仓管理',
				icon: 'icon2-zhuancangguanli',
				weigh: 1,
			},
			
			log: {
				route: '/inventorylog/list',
				title: '库存台账',
				icon: 'icon2-kucunliushui',
				weigh: 1,
			},
		}
	},
	finance: {
		module: '财务管理',
		theme: 'color_r',
		menu: {
			incomeorder: {
				route: '/incomeorder/list',
				title: '收款管理',
				icon: 'icon2-xiaoshoushoukuan',
				weigh: 1,
			},
			payorder: {
				route: '/payorder/list',
				title: '付款管理',
				icon: 'icon2-caiwufukuan',
				weigh: 1,
			},
			usdtormb: {
				route: '/exchange/list',
				title: '美金兑换人民币',
				icon: 'icon2-huanhui',
				weigh: 1,
			},
		}
	}
};

export default menu;